/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { getConfig } from 'blb-utils/config';
export const getRedirectURLForLendingPivot = (clientAppId, principalId, relayState) => {
  const config = getConfig();
  const baseIdentityURL = config.identityUrl;
  const queryParams = new URLSearchParams();
  queryParams.append('clientAppId', clientAppId);
  queryParams.append('principalId', principalId);
  if (relayState) queryParams.append('relayState', relayState);
  return `${baseIdentityURL}/auth/workspace-to-lending?${queryParams.toString()}`;
};